import {useParams} from 'react-router-dom'
import { NO_DATA_AVAILABLE } from '../../../constants/common'
import {getRequest} from '../../../services/base'
import {downloadFileBlob} from '../../../utils/common'
import {NavContext} from '../../../context/global_context'
import {useContext} from 'react'

import {Button, Dropdown} from 'antd'
import {DownOutlined, ExportOutlined,} from '@ant-design/icons'
import {useIntl} from 'react-intl'

const DownloadInlines = ({ isButton = true }) => {
  const intl = useIntl()
  let { vehicle } = useParams()
  const [navState, navDispatch] = useContext(NavContext)

  const downloadInlineCsv = async ({ key: file_type }) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'inlineConnections.downloadingFile' }, { file_type }),
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/inline_connection/download/?vehicle=${vehicle}&file_type=${file_type}`,
      true,
      true
    )
    // `res?.msg` is redundant: base.js sets status false on every failure,
    // and an error body is never a Blob.
    if (res?.status === false || !(res instanceof Blob)) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type:
            res?.code === NO_DATA_AVAILABLE ? 'info' : 'error',
          msg: intl.formatMessage({
            id:
              res?.code === NO_DATA_AVAILABLE
                ? 'generic.noDataToExport'
                : 'inlineConnections.downloadError',
          }),
        },
      })
    } else {
      downloadFileBlob(res, `${vehicle}_inline_${file_type}.csv`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: intl.formatMessage({ id: 'inlineConnections.downloadCompleted' }),
        },
      })
    }
  }

  const items = [
    {
      key: 'suffix',
      label: `${intl.formatMessage({ id: 'forms.download' })} ${intl.formatMessage({ id: 'importers.suffix' })}`,
      // icon: <MenuOutlined/>,
      icon: <ExportOutlined />,
    },
    {
      key: 'prefix',
      label: `${intl.formatMessage({ id: 'forms.download' })} ${intl.formatMessage({ id: 'importers.prefix' })}`,
      // icon: <MenuOutlined/>,
      icon: <ExportOutlined />,
    },
  ]

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      menu={{
        items,
        onClick: downloadInlineCsv,
      }}
    >
      {isButton ? (
        <Button>
          {intl.formatMessage({ id: 'forms.download' })} <DownOutlined />
        </Button>
      ) : (
        <Button type="link" className="link-button export-prefix-suffix">
          {intl.formatMessage({ id: 'forms.download' })}{' '}
          {intl.formatMessage({ id: 'importers.prefix' })}/
          {intl.formatMessage({ id: 'importers.suffix' })}
        </Button>
      )}
    </Dropdown>
  )
}

export default DownloadInlines
